module.exports = __webpack_public_path__ + "static/media/noquis.7b3e6ebc.jpg";